import { defineMessages } from 'react-intl'

const scope = `procurify.modules.reports.config.reportConfigs`

export default defineMessages({
  vendorReportTitle: {
    id: `${scope}.vendorReportTitle`,
    defaultMessage: 'Orders by vendor',
  },
  // Angular's singular "Order by user" anomaly is intentionally corrected.
  userReportTitle: {
    id: `${scope}.userReportTitle`,
    defaultMessage: 'Orders by user',
  },
  secondaryCategoryReportTitle: {
    id: `${scope}.secondaryCategoryReportTitle`,
    defaultMessage: 'Orders by {singularSecondaryOrgCategoryLabelLowercase}',
  },
  expenseReportTitle: {
    id: `${scope}.expenseReportTitle`,
    defaultMessage: 'Expenses by {singularSecondaryOrgCategoryLabelLowercase}',
  },
  ordersSectionHeading: {
    id: `${scope}.ordersSectionHeading`,
    defaultMessage: 'Orders',
  },
  expensesSectionHeading: {
    id: `${scope}.expensesSectionHeading`,
    defaultMessage: 'Expenses',
  },
  exportOrdersButtonLabel: {
    id: `${scope}.exportOrdersButtonLabel`,
    defaultMessage: 'Export orders',
  },
  exportExpenseItemsButtonLabel: {
    id: `${scope}.exportExpenseItemsButtonLabel`,
    defaultMessage: 'Export expense items',
  },
  orderItemsExportTypeLabel: {
    id: `${scope}.orderItemsExportTypeLabel`,
    defaultMessage: 'Order items',
  },
  expenseItemsExportTypeLabel: {
    id: `${scope}.expenseItemsExportTypeLabel`,
    defaultMessage: 'Expense items',
  },
  topVendorsChartHeading: {
    id: `${scope}.topVendorsChartHeading`,
    defaultMessage: 'Top vendors',
  },
  topSpendChartHeading: {
    id: `${scope}.topSpendChartHeading`,
    defaultMessage: 'Top spend',
  },
  usersAxisLabel: {
    id: `${scope}.usersAxisLabel`,
    defaultMessage: 'Users',
  },
  topSecondaryCategoriesChartHeading: {
    id: `${scope}.topSecondaryCategoriesChartHeading`,
    defaultMessage: 'Top {pluralSecondaryOrgCategoryLabelLowercase}',
  },
  totalSpendingTileLabel: {
    id: `${scope}.totalSpendingTileLabel`,
    defaultMessage: 'Total spending',
  },
  totalVendorsUsedTileLabel: {
    id: `${scope}.totalVendorsUsedTileLabel`,
    defaultMessage: 'Total vendors used',
  },
  totalItemsPurchasedTileLabel: {
    id: `${scope}.totalItemsPurchasedTileLabel`,
    defaultMessage: 'Total items purchased',
  },
  spendByUserTileLabel: {
    id: `${scope}.spendByUserTileLabel`,
    defaultMessage: 'Spend by user',
  },
  totalSecondaryCategoryUsageTileLabel: {
    id: `${scope}.totalSecondaryCategoryUsageTileLabel`,
    defaultMessage: 'Total {singularSecondaryOrgCategoryLabelLowercase} usage',
  },
  totalAccountCodesUsedTileLabel: {
    id: `${scope}.totalAccountCodesUsedTileLabel`,
    defaultMessage: 'Total account codes used',
  },
  accountCodesUsedTileLabel: {
    id: `${scope}.accountCodesUsedTileLabel`,
    defaultMessage: 'Account codes used',
  },
  numberOfItemsPurchasedTileLabel: {
    id: `${scope}.numberOfItemsPurchasedTileLabel`,
    defaultMessage: 'Number of items purchased',
  },
  totalReimbursementTileLabel: {
    id: `${scope}.totalReimbursementTileLabel`,
    defaultMessage: 'Total reimbursement',
  },
  totalExpenditureTileLabel: {
    id: `${scope}.totalExpenditureTileLabel`,
    defaultMessage: 'Total expenditure',
  },
  vendorNotFoundHeader: {
    id: `${scope}.vendorNotFoundHeader`,
    defaultMessage: 'Vendor not found',
  },
  userNotFoundHeader: {
    id: `${scope}.userNotFoundHeader`,
    defaultMessage: 'User not found',
  },
  secondaryCategoryNotFoundHeader: {
    id: `${scope}.secondaryCategoryNotFoundHeader`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel} not found',
  },
})
